import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "toastr/build/toastr.min.css";
import toastr from "toastr";
import "./MembersModal.css";
import {
  ChevronLeft,
  ChevronRight,
  CirclePlus,
  Trash2Icon,
} from "lucide-react";
import apiServiceHandler from "../../../service/apiService";
import { useDispatch, useSelector } from "react-redux";
import HashLoader from "react-spinners/HashLoader";
import { handleLoadUsers, hanldeGroupData } from "../../../redux/groupData";
import { getColorFromName } from "../../../utils/getColor";
import ReactPaginate from "react-paginate";

const headers = ["USER", "ACTIONS"];

const MembersModal = ({
  isOpen,
  onClose,
  selectedOption,
  searchQuery,
  setSearchQuery,
  allUsers,
  setAllUsers,
  itemOffset,
  setItemOffset,
  totalUsers,
  setTotalUsers,
}) => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const groupInfo = useSelector((state) => state.groupData.groupInfo);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const getAllUsers = async () => {
    try {
      setLoading(true);
      const response = await apiServiceHandler(
        "GET",
        `api/groups/members/not/in/${groupInfo?._id}?page=${itemOffset}`,
        {}
      );
      // console.log(response.data.users, 'User is here...')
      setAllUsers(response?.data?.users);
      setTotalUsers(response?.data?.totalCount);
      setLoading(false);
    } catch (error) {
      console.error("Error getting getAllUsers:", error);
      setLoading(false);
    }
  };

  const getAllMembers = async () => {
    try {
      setLoading(true);

      const response = await apiServiceHandler(
        "GET",
        `api/groups/members/${groupInfo._id}?page=${itemOffset}`,
        {}
      );
      setAllUsers(response?.data?.users);
      setTotalUsers(response?.data?.totalCount);
      setLoading(false);
    } catch (error) {
      console.error("Error getting getAllUsers:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen && selectedOption === "add") {
      getAllUsers();
    } else {
      getAllMembers();
    }
  }, [isOpen, itemOffset]);

  const handleUser = async (id) => {
    try {
      const payload = {
        userId: id,
        groupId: groupInfo?._id,
        type: selectedOption === "add" ? "add" : "remove",
      };
      const response = await apiServiceHandler(
        "POST",
        "api/groups/members",
        payload
      );
      toastr.success(response.message);
      dispatch(hanldeGroupData(true));
      setAllUsers((prevUsers) => prevUsers.filter((user) => user._id !== id));
    } catch (error) {
      toastr.error("Please Try Again.");
      setLoading(false);
    }
  };

  const filteredUsers = allUsers?.filter((user) => {
    return (
      user.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      user.email.toLowerCase().includes(searchQuery.toLowerCase())
    );
  });

  useEffect(() => {
    setItemOffset(0);
  }, [searchQuery]);

  const itemsPerPage = 10;
  const pageCount = Math.ceil(totalUsers / itemsPerPage);

  const handlePageClick = (event) => {
    setItemOffset(event.selected);
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered size="xl" className="w-100">
      <Modal.Header closeButton style={{ borderBottom: "none" }}>
        <Modal.Title>
          {selectedOption === "add" ? "Add New Members" : "Group Members"}
        </Modal.Title>
        <div className="group-modal-search-field">
          <div className="text-input-wrapper">
            <input
              type="text"
              className="text-input"
              placeholder="search by name, email"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <span className="icon">{/* Your Search Icon Here */}</span>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        <div className="members-data-table">
          <div className="members-data-table__table">
            {!loading ? (
              <>
                <div className="members-data-table__header">
                  {headers.map((header) => (
                    <div className="data-table__header-cell" key={header}>
                      <div style={{ display: "flex" }}>
                        <span className="header-text-label">{header}</span>
                      </div>
                    </div>
                  ))}
                </div>

                {filteredUsers && filteredUsers.length > 0 ? (
                  filteredUsers.map((user, index) => (
                    <div className="members-data-table__body" key={index}>
                      <div
                        className={`members-data-table__row-${index % 2 === 0 ? "odd" : "even"
                          }`}
                      >
                        <div className="member-data-table__cell--name">
                          <div className="data-table__cell-body">
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <div
                                className="member-avatar"
                                style={{
                                  backgroundColor: getColorFromName(user.name),
                                }}
                              >
                                <div className="member-avatar__text">
                                  {user && user.image ? (
                                    <img
                                      className="avatar__image"
                                      src={user.image}
                                      alt="User Avatar"
                                    />
                                  ) : (
                                    <div className="user__avatar">
                                      {user?.name.substr(0, 1)}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <span style={{ marginLeft: "1rem" }}>
                                {user.name}
                              </span>
                            </div>
                          </div>
                        </div>
                        {/* <div className="member-data-table__cell--email">
                          <div className="member-data-table__cell-body">
                            <div className="member__email">{user.email}</div>
                          </div>
                        </div> */}
                        <div className="member-data-table__cell--actions">
                          <div className="member-data-table__cell-body">
                            {userDetails?.admin && (
                              <button
                                className="add__members"
                                onClick={() => handleUser(user?._id)}
                              >
                                {selectedOption === "add" ? (
                                  <CirclePlus
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      color: "#d1b794",
                                    }}
                                  />
                                ) : (
                                  <Trash2Icon
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      color: "#d1b794",
                                    }}
                                  />
                                )}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No User Found</p>
                )}
              </>
            ) : (
              <div className="member-loader">
                <HashLoader color="#d1b794" size={30} />
                <p>Loading Users</p>
              </div>
            )}
          </div>
        </div>
      </Modal.Body>

      <div
        style={
          loading
            ? { display: "none" }
            : {
              display: "flex",
              justifyContent: "center",
              padding: "0px 20px",
              width: "100%",
              alignItems: "center",
            }
        }
      >
        <ReactPaginate
          containerClassName={"pagination"}
          pageClassName={"user-page-item"}
          activeClassName={"user-active"}
          onPageChange={handlePageClick}
          pageCount={pageCount}
          nextLabel={
            pageCount > 1 ? (
              <ChevronRight className="pagination-btn"
                size={40}
                style={{
                  fontSize: 16,
                  width: 150,
                  height: 25,
                  color: "#604b51",
                  background: "#d1b794",
                  borderRadius: "50px",
                  width: "fit-content",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              />
            ) : null
          }
          previousLabel={
            pageCount > 1 ? (
              <ChevronLeft className="pagination-btn"
                size={40}
                style={{
                  fontSize: 16,
                  width: 150,
                  height: 25,
                  color: "#604b51",
                  background: "#d1b794",
                  borderRadius: "50px",
                  width: "fit-content",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              />
            ) : null
          }
        />
      </div>
    </Modal>
  );
};

export default MembersModal;
